<template>
  <v-data-table
    :headers="headers"
    :items="businesses"
    :pagination.sync="pagination"
    class="business-table"
  >
    <template slot="items" slot-scope="props">
      <td class="business-title">
        <router-link :to="props.item.url">{{ props.item.title }}</router-link>
      </td>
      <td class="business-opening-date">
        {{ props.item.opening_date | toLocaleDateString }}
      </td>
      <td class="business-kind">
        {{ props.item.kind }}
      </td>
      <td class="business-status">
        {{ props.item.status }}
      </td>
      <td v-if="$isSuperuser()" class="business-published">
        <PublishedChip :value="props.item" />
      </td>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'BusinessTable',
  props: {
    businesses: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      pagination: {
        descending: true,
        sortBy: 'opening_date',
        rowsPerPage: 25,
      },
      headers: [
        { text: 'Titel', value: 'title' },
        { text: 'Eröffnungsdatum', value: 'opening_date' },
        { text: 'Geschäftsart', value: 'kind' },
        { text: 'Status', value: 'status' },
        ...(this.$isSuperuser() ? [{ text: 'Publikation', value: 'is_published' }] : []),
      ],
    };
  },
};
</script>
